import ImeiCheck from "@/services/imei.service.js";
import { convertHTMLEntity } from "@/global/functions.js";

// For display popup duplicate order
export default async function displayDuplicateWarn(vue, timeDiff, formData, navigate, duplicatedOrder, servicePrice) {
    const result = await vue.$swal({
        title: 'Already Checked',
        html: `<p style="margin:0;color:#666;font-size:0.95rem;">This IMEI was checked <strong>${timeDiff}</strong></p>`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Show Result',
        cancelButtonText: 'Reorder',
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
    })

    // Show Result (confirm = primary button)
    if (result.value) {
        vue.$swal({
            title: 'Previous Result',
            html: convertHTMLEntity(duplicatedOrder),
            icon: 'success',
            confirmButtonText: 'OK',
            customClass: {
                confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
        })
    }

    // Reorder (cancel button)
    if (!result.value && result.dismiss !== 'backdrop') {
        vue.loading = true;
        await ImeiCheck.single({ ...formData, duplicate: false }, servicePrice)
            .then((data) => navigate(data))
            .catch(() => {
                vue.$swal({
                    title: 'Error',
                    text: 'Please try again this service later',
                    icon: 'error',
                    confirmButtonText: 'Ok',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                })
            })
        vue.loading = false;
    }
}